export default {
  // Production
  // pageid: '102549712095297', // main
  // UAT
  pageid: '105387828535129', // test
  COMMU: 'https://api-enterprise.zwiz.app',
  domain: 'https://connect.nextcapital.co.th'
}

// "https://communitybotbyzwizai.herokuapp.com"
// http://localhost:5000
